import React, { Component, Fragment } from 'react';
import { BookOpen, Download, ChevronLeft, ChevronRight } from "react-feather";
import { Button } from "reactstrap";
import { Document, Page } from 'react-pdf/dist/entry.webpack';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import '../../../assets/scss/pages/app-library.scss'
import { toast } from 'react-toastify';


class UploadPreview extends Component {

  static getDerivedStateFromProps(props, state){
    if (props.file !== state.file){
      return { 
        file: props.file,
        numPages: null,
        pageNumber: 1,
        thumbPageNo: 1
      }
    }
    return null;
  }

  state = {
    numPages: null,
    pageNumber: 1,
    file: null,
    width: 350,
    rerender: true,
    thumbPageNo: 1
  }

  componentDidMount = () => {
    window.addEventListener("resize", this.updateDimensions);    
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }

  updateDimensions = () => {
    if(document.getElementById('preview-file-upload')){
      let w = document.getElementById('preview-file-upload').getBoundingClientRect().width;
      w = w > 532 ? 532 : w-3;
      this.setState({
        width: w-2
      })
    }
  }

  resizeInitial = () => {
    if(document.getElementById('preview-file-upload')){
      let w = document.getElementById('preview-file-upload').getBoundingClientRect().width;
      w = w > 532 ? 532 : w-3;
      this.setState({
        width: w-2,
        rerender: false
      })
    }
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
    const data = {
      file: this.state.file,
      thumbPageNo: 1,
      pages: numPages
    }
    this.props.updateFileInfo(data)
  }

  next = () => {
    this.setState(prevState => ({
      pageNumber: prevState.pageNumber < prevState.numPages ? prevState.pageNumber+1 : prevState.pageNumber
    }))
  }

  previous = () => {
    this.setState(prevState => ({
      pageNumber: prevState.pageNumber > 1 ? prevState.pageNumber-1 : prevState.pageNumber
    }))
  }

  thumbNailChange = (pageNumber) => {
    this.setState({thumbPageNo: pageNumber}); 
    toast.info(`Page ${pageNumber} is Selected as Thumbnail`);
    const data = {
      file: this.state.file,
      thumbPageNo: pageNumber,
      pages: this.state.numPages
    }
    this.props.updateFileInfo(data);
  }

  render() {
    const { pageNumber, numPages } = this.state;
    const size = this.state.file ? (this.state.file.size * 0.000001).toFixed(2) : null;
    if (size && this.state.rerender){
      this.resizeInitial()
    }
    return (
      <Fragment>
        <div id="preview-file-upload" className="d-flex flex-column align-items-center justify-content-center preview-file-container" >
          <Document
            file={this.state.file}
            onLoadSuccess={this.onDocumentLoadSuccess}
            className={'pdf-doc-cls'}
            height={350}
            noData={"Please select a file."}
          >
            <Page 
              className={'pdf-page-cls'}
              renderMode={"canvas"}
              pageNumber={pageNumber} 
              width={this.state.width}
              onRenderError={(error) => alert('Error while loading file! ' + error.message)}
            />
          </Document>
        </div>
        
        { numPages ? 
          <div className="file-preview-control">
            <div className="mt-2 mb-2">
              <Button
                size="sm"
                outline
                color="primary"
                onClick={this.previous} 
              >
                <ChevronLeft size={15} />
              </Button>
              <span className="mr-1 ml-1">{pageNumber}/{numPages}</span>
              <Button
                size="sm"
                outline
                color="primary"
                onClick={this.next}
              >
                <ChevronRight size={15} />
              </Button>
              <Button
                outline
                className="float-r"
                color="primary"
                onClick={()=>{this.thumbNailChange(pageNumber)}}
              >
                Set as Thumbnail
              </Button>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-2">
          <div>
            <Download size={20}></Download>
            <label>Size : {size} MB</label>
          </div>
          <div>
            <BookOpen size={20}></BookOpen>
            <label> No of Pages: {numPages}</label>
          </div>
        </div>
          </div>
         : <div></div> }
        
      </Fragment>
    );
  }
}

export default UploadPreview;